import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import TouchAppOutlinedIcon from "@mui/icons-material/TouchAppOutlined";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import AddCardIcon from "@mui/icons-material/AddCard";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import AvTimerIcon from "@mui/icons-material/AvTimer";
import LockIcon from "@mui/icons-material/Lock";
import CropSquareIcon from "@mui/icons-material/CropSquare";
import SortOutlinedIcon from "@mui/icons-material/SortOutlined";
import FormatLineSpacingIcon from "@mui/icons-material/FormatLineSpacing";

import ForwardIcon from "@mui/icons-material/Forward";
import { useTranslation } from "react-i18next";

const OurServicesProcess = () => {
  const { t } = useTranslation();
  const [visibleSections, setVisibleSections] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setVisibleSections((prevVisibleSections) => prevVisibleSections + 1);

      // Display all sections after the last one
      if (visibleSections >= 4) {
        clearInterval(interval);
      }
    }, 1000); // Change the interval time as needed

    return () => clearInterval(interval);
  }, [visibleSections]);

  const variants = {
    initial: {
      y: 100,
      opacity: 0,
    },
    animate: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5,
      },
    },
  };

  const renderSection = (sectionNumber) => {
    const sectionClassName = `section${sectionNumber + 1} pb-6 mt-4 md:mb-2 ${
      sectionNumber < visibleSections ? "visible" : "hidden"
    }`;

    return (
      <motion.div
        variants={variants}
        initial="initial"
        whileInView="animate"
        className={sectionClassName}
      >
        <div className="relative w-20 h-20 transition-transform duration-500 ease-in-out">
          {/* <!-- First circle --> */}
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/4 -translate-y-1/2 w-20 h-20 bg-white border-2 border-[#b4530a] rounded-full items-center">
            {sectionNumber === 0 && (
              <>
                <TouchAppOutlinedIcon
                  className="transform -rotate-45 -skew-y-12 items-center mt-5 ml-5"
                  style={{ width: 30, height: 35 }}
                />
                <CropSquareIcon
                  className="items-center  mt-4 -ml-10 bg-white "
                  style={{ width: 30, height: 30 }}
                />
                <SortOutlinedIcon
                  className="items-center  mt-5 bg-white "
                  style={{ width: 25, height: 25 }}
                />
                <p className="hidden md:block ">
                  <ForwardIcon
                    className=" text-[#b4530a] h-4 w-20 -mt-14 ms-16 hidden md:block"
                    style={{ width: 90, height: 30 }}
                  />
                </p>
              </>
            )}

            {sectionNumber === 1 && (
              <>
                <EditCalendarIcon
                  className="items-center mt-5 ml-6"
                  style={{ width: 40, height: 40 }}
                />
                <FormatLineSpacingIcon
                  className="items-center  mt-5 -ml-9 bg-white "
                  style={{ width: 20, height: 20 }}
                />
                <p className="hidden md:block text-center items-center">
                  <ForwardIcon
                    className=" text-[#b4530a] h-4 w-30 -mt-14 ms-14 hidden md:block"
                    style={{ width: 90, height: 30 }}
                  />
                </p>
              </>
            )}
            {sectionNumber === 2 && (
              <>
                <AddCardIcon
                  className="items-center mt-4 ml-4"
                  style={{ width: 40, height: 40 }}
                />
                <LockIcon className="items-center  mt-7 -ml-4 bg-white rounded-full" />
                <p className="hidden md:block text-center items-center">
                  <ForwardIcon
                    className=" text-[#b4530a] h-4 w-30 -mt-14 ms-14 hidden md:block"
                    style={{ width: 90, height: 30 }}
                  />
                </p>
              </>
            )}
            {sectionNumber === 3 && (
              <>
                <LocalShippingIcon
                  className="items-center ms-5 mt-3"
                  style={{ width: 50, height: 50 }}
                />
                <AvTimerIcon className="items-center  mb-4 -ml-14 bg-white rounded-full" />
              </>
            )}
          </div>

          {/* <!-- Second circle --> */}
          <div className="absolute top-1/2 left-1/4 transform -translate-x-1/2 -translate-y-1/2 w-8 h-8 bg-[#b4530a] border-2 border-[#b4530a] rounded-full text-white text-center text-lg font-bold transition-all duration-500 ease-in-out">
            {sectionNumber + 1}
          </div>
        </div>

        <p className="pt-2">
          {sectionNumber === 0 && t("Home.serviceProcess.step1")}
          {sectionNumber === 1 && t("Home.serviceProcess.step2")}
          {sectionNumber === 2 && t("Home.serviceProcess.step3")}
          {sectionNumber === 3 && t("Home.serviceProcess.step4")}
        </p>
      </motion.div>
    );
  };

  return (
    <div className="mx-28 slow-motion-animation hover-slow-motion-animation">
      <h2 className="text-center text-xl">{t("Home.serviceProcess.title")}</h2>
      <p className="text-center text-sm">{t("Home.serviceProcess.p")}</p>
      <div className="flex flex-col md:flex-row items-center justify-evenly text-black mb-6 mt-6 md:mb-2 align-middle">
        {renderSection(0)}
        {visibleSections >= 2 && renderSection(1)}
        {visibleSections >= 3 && renderSection(2)}
        {visibleSections >= 4 && renderSection(3)}
      </div>
    </div>
  );
};

export default OurServicesProcess;
